import { render } from "./TermsOfUse.vue?vue&type=template&id=00519306"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"
script.render = render

export default script